/* eslint-disable jsx-a11y/anchor-is-valid */
import { FC, useEffect, useState, useRef } from 'react'
import { useMutation, useQueryClient } from 'react-query'
import { MenuComponent } from '../../../../../../../_metronic/assets/ts/components'
import { ID, KTIcon, QUERIES } from '../../../../../../../_metronic/helpers'
import { useListView } from '../../core/ListViewProvider'
import { useQueryResponse } from '../../core/QueryResponseProvider'
import { deleteUser, updateUser, createUser, updateUser2 } from '../../core/_requests'
import { useQueryRequest } from '../../core/QueryRequestProvider'
import { AssignHubModal } from './AssignPickUPBoy'
import GenerateQrCode from './GenerateQrCode'
import { useLocation } from 'react-router-dom'
import { useAuth } from '../../../../../auth'
import { UserConfirmationDelete } from './UserDeleteConfirmation'
import { successToast } from '../../../../../../../_metronic/helpers/components/Toaster'
import { useNavigate } from 'react-router-dom'
import ApprovalModal from './ApprovalModal'
// import { DdpModal } from './ViewDdp'
import DdpModal from './ViewDdp'
import SalesApprovalModal from './SalesApprovalModal'
import VerifyModal from './VerifyModal'
import ViewApproveModal from './ViewApproveModal'
import { DispatchHistory } from './DispatchHistory'

type Props = {
  id: any
  allData: any
  action: any
}

const UserActionsCell: FC<Props> = ({ id, allData, action = ['edit'] }) => {
  const [showApprovalModal, setShowApprovalModal] = useState(false)
  const [showSalesApprovalModal, setShowSalesApprovalModal] = useState(false)
  const [showVerifyModal, setShowVerifyModal] = useState(false)
  const navigate = useNavigate()
  const contentRef = useRef(null)
  const { itemIdForUpdate, setItemIdForUpdate } = useListView()
  const { query } = useQueryResponse()
  const queryClient = useQueryClient()
  const { state } = useQueryRequest()
  const [showPickUpModal, setShowAssignHubModal] = useState(false)
  const [showDeleteModal, setShowDeleteModal] = useState<any>(false)
  const [actionType, setActionType] = useState("")
  const [showDropdown, setShowDropdown] = useState(false)
  console.log("idddd", id)


  const [showDdpModal, setShowDdpModal] = useState(false)
  const [showApproveModal, setShowApproveModal] = useState(false)
  const [selectedId, setSelectedId] = useState<string | null>(null)
  const [showHistoryModal, setShowHistoryModal] = useState(false)
  // const shouldHideEdit = () => {
  //   // Add console logs to debug the issue
  //   // console.log('Current user:', currentUser)
  //   // console.log('Role structure:', (currentUser as any)?.role)

  //   // Business paths - only apply permissions logic in these paths
  //   const businessPaths = [
  //     '/apps/business/collection-point',
  //     '/apps/business/app-users',
  //     '/apps/business/logistics1',
  //     '/apps/business/userManagement',
  //   ]

  //   // Check if we're on a business path
  //   const isOnBusinessPath = businessPaths.some((path) => pathname.includes(path))
  //   console.log('Is on business path:', isOnBusinessPath)

  //   // If not on a business path, always show edit
  //   if (!isOnBusinessPath) {
  //     // console.log('Not on business path, showing edit')
  //     return false // Don't hide edit
  //   }

  //   // If role is null, show edit
  //   if ((currentUser as any)?.role?.role === null) {
  //     // console.log('Role is null, showing edit')
  //     return false // Don't hide edit
  //   }

  //   // Find business role
  //   const businessRole = (currentUser as any)?.role?.role?.find((rol) => rol?.type === 'BUSINESS')
  //   // console.log('Business role:', businessRole)

  //   // If no business role, hide edit
  //   if (!businessRole) {
  //     // console.log('No business role, hiding edit')
  //     return true // Hide edit
  //   }

  //   // console.log('Update permission:', businessRole.permissions?.update)
  //   // console.log('Update permission type:', typeof businessRole.permissions?.update)

  //   // Try various comparisons to see which one works
  //   const strictEqual = businessRole.permissions?.update === true
  //   const looseEqual = businessRole.permissions?.update == true
  //   const stringTrue = businessRole.permissions?.update === 'true'
  //   const truthy = !!businessRole.permissions?.update

  //   /*  console.log('Strict equal to true:', strictEqual)
  //   console.log('Loose equal to true:', looseEqual)
  //   console.log("Equal to 'true' string:", stringTrue)
  //   console.log('Is truthy:', truthy) */

  //   // Return based on update permission
  //   return !strictEqual
  // }






















  // trying role mannagment starts here
  // Function for business paths

  const location = useLocation()

  const allowedPaths = [
    '/apps/business/recycler',
    '/apps/business/collection-point',
    '/apps/finance/recycler',
    '/apps/finance/collection-point'
  ]

  const showDeactivate = allowedPaths.includes(location.pathname)
  const shouldHideSettingsEdit = () => {
    // Settings paths - apply permissions logic for these paths
    const settingsPaths = [
      '/apps/settings/category',
      '/apps/settings/sub-category',
      '/apps/settings/pricing',
      '/apps/settings/processing-routes',
      '/apps/settings/delivery-terms',
      '/apps/settings/grade',
      '/apps/settings/role',
      '/apps/settings/quality-remarks',
    ]

    // Check if we're on a settings path
    const isOnSettingsPath = settingsPaths.some((path) => pathname.includes(path))
    console.log('Is on settings path:', isOnSettingsPath)

    // If not on a settings path, always show edit
    if (!isOnSettingsPath) {
      return false // Don't hide edit
    }

    // If role.role is null, show edit immediately without further checks
    if ((currentUser as any)?.role?.role === null) {
      console.log('role.role is null, showing edit');
      return false // Don't hide edit
    }

    // Find settings role (only if we have a role array)
    const userRole = (currentUser as any)?.role?.role || [];
    const settingsRole = userRole.find((rol) => rol?.type === 'SETTINGS');
    // If no settings role, hide edit
    if (!settingsRole) {
      console.log('No settings role, hiding edit');
      return true // Hide edit
    }

    // Return based on update permission
    return !(settingsRole.permissions?.update === true);
  }








  const shouldHideEditBusiness = () => {
    // Business paths - only apply permissions logic in these paths
    const businessPaths = [
      '/apps/business/collection-point',
      '/apps/business/app-users',
      '/apps/business/logistics1',
      '/apps/business/userManagement',
    ]

    // Check if we're on a business path
    const isOnBusinessPath = businessPaths.some((path) => pathname.includes(path))
    console.log('Is on business path:', isOnBusinessPath)

    // If not on a business path, always show edit
    if (!isOnBusinessPath) {
      return false // Don't hide edit
    }

    // If role.role is null, show edit immediately without further checks
    if ((currentUser as any)?.role?.role === null) {
      console.log('role.role is null, showing edit');
      return false // Don't hide edit
    }

    // Find business role (only if we have a role array)
    const userRole = (currentUser as any)?.role?.role || [];
    const businessRole = userRole.find((rol) => rol?.type === 'BUSINESS');

    // If no business role, hide edit
    if (!businessRole) {
      console.log('No business role, hiding edit');
      return true // Hide edit
    }

    // Return based on update permission
    return !(businessRole.permissions?.update === true);
  }

  // Function for finance paths
  const shouldHideEditFinance = () => {
    // Finance paths - apply finance permissions logic in these paths
    const financePaths = [
      '/apps/finance/collection-point',
      '/apps/finance/approved-listing',
      '/apps/finance/supply-orders2',
      '/apps/finance/payment',
      '/apps/finance/payablesFinance',
      '/apps/finance/receivables'
    ]

    // Check if we're on a finance path
    const isOnFinancePath = financePaths.some((path) => pathname.includes(path))
    console.log('Is on finance path:', isOnFinancePath)

    // If not on a finance path, always show edit
    if (!isOnFinancePath) {
      return false // Don't hide edit
    }

    // If role.role is null, show edit immediately without further checks
    if ((currentUser as any)?.role?.role === null) {
      console.log('role.role is null, showing edit');
      return false // Don't hide edit
    }

    // Find finance role (only if we have a role array)
    const userRole = (currentUser as any)?.role?.role || [];
    const financeRole = userRole.find((rol) => rol?.type === 'FINANCE');

    // If no finance role, hide edit
    if (!financeRole) {
      console.log('No finance role, hiding edit');
      return true // Hide edit
    }

    // Return based on update permission
    return !(financeRole.permissions?.update === true);
  }

  const shouldHideEditLogistics = () => {
    // Logistics paths - apply logistics permissions logic in these paths
    const logisticsPaths = [
      '/apps/logic/logistics1',
      '/apps/logic/assign-vehicle',
      '/apps/logic/payables'
    ]

    // Check if we're on a logistics path
    const isOnLogisticsPath = logisticsPaths.some((path) => pathname.includes(path))
    console.log('Is on logistics path:', isOnLogisticsPath)

    // If not on a logistics path, always show edit
    if (!isOnLogisticsPath) {
      return false // Don't hide edit
    }

    // If role.role is null, show edit immediately without further checks
    if ((currentUser as any)?.role?.role === null) {
      console.log('role.role is null, showing edit');
      return false // Don't hide edit
    }

    // Find logistics role (only if we have a role array)
    const userRole = (currentUser as any)?.role?.role || [];
    const logisticsRole = userRole.find((rol) => rol?.type === 'LOGISTIC');

    // If no logistics role, hide edit
    if (!logisticsRole) {
      console.log('No logistics role, hiding edit');
      return true // Hide edit
    }

    // Return based on update permission
    return !(logisticsRole.permissions?.update === true);
  }

  // Function for purchase paths
  const shouldHideEditPurchase = () => {
    // Purchase paths - apply purchase permissions logic in these paths
    const purchasePaths = [
      '/apps/purchase/varified-listing',
      '/apps/purchase/order-management',
      '/apps/purchase/assign-vehicle',
      '/apps/purchase/reconcillation',
      '/apps/purchase/collection-point',
      '/apps/purchase/app-users'
    ]

    // Check if we're on a purchase path
    const isOnPurchasePath = purchasePaths.some((path) => pathname.includes(path))
    console.log('Is on purchase path:', isOnPurchasePath)

    // If not on a purchase path, always show edit
    if (!isOnPurchasePath) {
      return false // Don't hide edit
    }

    // If role.role is null, show edit immediately without further checks
    if ((currentUser as any)?.role?.role === null) {
      console.log('role.role is null, showing edit');
      return false // Don't hide edit
    }

    // Find purchase role (only if we have a role array)
    const userRole = (currentUser as any)?.role?.role || [];
    const purchaseRole = userRole.find((rol) => rol?.type === 'PURCHASE');

    // If no purchase role, hide edit
    if (!purchaseRole) {
      console.log('No purchase role, hiding edit');
      return true // Hide edit
    }

    // Return based on update permission
    return !(purchaseRole.permissions?.update === true);
  }

  // Function for sales paths
  const shouldHideEditSales = () => {
    // Sales paths - apply sales permissions logic in these paths
    const salesPaths = [
      '/apps/sales/purchase-request-admin',
      '/apps/sales/order-management',
      '/apps/sales/reconcillation'
    ]

    // Check if we're on a sales path
    const isOnSalesPath = salesPaths.some((path) => pathname.includes(path))
    console.log('Is on sales path:', isOnSalesPath)

    // If not on a sales path, always show edit
    if (!isOnSalesPath) {
      return false // Don't hide edit
    }

    // If role.role is null, show edit immediately without further checks
    if ((currentUser as any)?.role?.role === null) {
      console.log('role.role is null, showing edit');
      return false // Don't hide edit
    }

    // Find sales role (only if we have a role array)
    const userRole = (currentUser as any)?.role?.role || [];
    const salesRole = userRole.find((rol) => rol?.type === 'SALE');

    // If no sales role, hide edit
    if (!salesRole) {
      console.log('No sales role, hiding edit');
      return true // Hide edit
    }
    // Return based on update permission
    return !(salesRole.permissions?.update === true);
  }



  // Function for transactions paths
  const shouldHideEditTransactions = () => {
    // Transactions paths - apply transactions permissions logic in these paths
    const transactionsPaths = [
      '/apps/transactions/payment-info',
      '/apps/transactions/quality-assessment',
      '/apps/transactions/receivables-recycler'
    ]










    // Check if we're on a transactions path
    const isOnTransactionsPath = transactionsPaths.some((path) => pathname.includes(path))
    console.log('Is on transactions path:', isOnTransactionsPath)

    // If not on a transactions path, always show edit
    if (!isOnTransactionsPath) {
      return false // Don't hide edit
    }

    // If currentUser has no role key at all, show edit
    if (!(currentUser as any)?.role) {
      console.log('role key does not exist in currentUser, showing edit');
      return false // Don't hide edit
    }

    // If role.role is null, show edit immediately without further checks
    if ((currentUser as any)?.role?.role === null) {
      console.log('role.role is null, showing edit');
      return false // Don't hide edit
    }

    // Find transactions role (only if we have a role array)
    const userRole = (currentUser as any)?.role?.role || [];
    const transactionsRole = userRole.find((rol) => rol?.type === 'TRANSACTIONS');

    // If no transactions role, hide edit
    if (!transactionsRole) {
      console.log('No transactions role, hiding edit');
      return true // Hide edit
    }

    // Return based on update permission
    return !(transactionsRole.permissions?.update === true);
  }

  // Function for textile paths
  const shouldHideEditTextile = () => {
    const textilePaths = [
      '/apps/textile/textile-user-managment',
      '/apps/textile/textile-order-approval',
      '/apps/textile/textile-dispatch',
    ]

    const isOnTextilePath = textilePaths.some((path) => pathname.includes(path))

    if (!isOnTextilePath) {
      return false
    }

    return false
  }

  // trying role mannagment ends here




























































































  const { currentUser } = useAuth()
  console.log('currentttt', (currentUser as any)?.role?.role, currentUser)

  const { pathname } = useLocation()

  useEffect(() => {
    MenuComponent.reinitialization()
  }, [])

  const openEditModal = (showView = false) => {
    setItemIdForUpdate(id)
    // setItemIdForUpdate({...id, showView})
  }
  const assignPostMethod = useMutation(
    (payload: any) => createUser(payload, `smart-centre/order/assign-agent`),
    {
      // 💡 response of the mutation is passed to onSuccess
      onSuccess: () => {
        // ✅ update detail view directly
        queryClient.invalidateQueries([`return123/orders-${query}`])
        setShowAssignHubModal(false)
      },
    }
  )



  // const deleteItem = useMutation(
  //   () =>
  //     updateUser(
  //       {},
  //       // `categories/${id.id}/update`
  //     ),
  //   {
  //     // 💡 response of the mutation is passed to onSuccess
  //     onSuccess: () => {
  //       // ✅ update detail view directly
  //       queryClient.invalidateQueries([`${QUERIES.USERS_LIST}-${query}`])
  //     },
  //   }
  // )



  const deleteItem = useMutation(
    () =>
      updateUser2(
        // {},
        // `categories/${id.id}/update`
        `user/${id.id}/status?status=INACTIVE&type=${id.userType}`
      ),
    {
      // 💡 response of the mutation is passed to onSuccess
      onSuccess: () => {
        // ✅ update detail view directly
        queryClient.invalidateQueries([`${QUERIES.USERS_LIST}-${query}`])
      },
    }
  )

  const showAssignHubModal = () => {
    setShowAssignHubModal(true)
  }

  const toggleStatus = useMutation(
    () =>
      updateUser(
        {},
        `user/${id.id}/status?type=${state.type || 'deals'}&status=${id.status === 'ACTIVE' ? 'INACTIVE' : 'ACTIVE'
        }`
      ),
    {
      // 💡 response of the mutation is passed to onSuccess
      onSuccess: () => {
        // ✅ update detail view directly
        queryClient.invalidateQueries([`${QUERIES.USERS_LIST}-${query}`])
      },
    }
  )
  const [showQrCode, setShowQrCode] = useState(false)
  // const test = pathname.includes('/apps/transactions/approved-listing')
  const test = pathname.includes('/apps/finance/approved-listing')
    ? id?.images?.filter((x) => x?.docType === 'PO_IMAGE')
    : []

  const test2 = pathname.includes('/apps/finance/supply-orders2')
    ? id?.dispatchImages?.filter((x) => x?.docType === 'PFC_INVOICE')
    : []

  const test3 = id?.status === 'DISPATCHED' ? true : false

  // console.log(test3)

  const isRecyclerPath = pathname.includes('/apps/transactions/receivables-recycler')
  const isSupplierPath = pathname.includes('/apps/finance/payablesFinance')

  console.log("currentUserrr", (currentUser as any)?.role?.name, currentUser)

  // Determine which payment type to check based on path
  const hasCompletedPayment =
    action.includes('payment0') &&
    // For recycler path, check RECYCLER payments
    ((isRecyclerPath &&
      id?.payment?.paymentDetails?.some(
        (payment) => payment.paymentType === 'RECYCLER' && payment.remainingPayable <= 0
      )) ||
      // For supplier path, check SUPPLIER payments
      (isSupplierPath &&
        id?.payment?.paymentDetails?.some(
          (payment) => payment.paymentType === 'SUPPLIER' && payment.remainingPayable <= 0
        )))

  return (
    <>
      {(action.includes('view_certificate') && (
        <a
          onClick={() => openEditModal()}
          className='btn btn-icon btn-bg-light btn-active-color-primary btn-sm me-1'
        >
          <KTIcon iconName='eye' className='fs-3' />
        </a>
      )) ||
        false}
      {showPickUpModal && (
        <AssignHubModal
          id={id}
          confirm={async (payload) => await assignPostMethod.mutateAsync(payload)}
          close={() => setShowAssignHubModal(false)}
        />
      )}



      {showDeleteModal && (
        <UserConfirmationDelete
          data={id}
          actionType={actionType}
          close={() => {
            setShowDeleteModal(false)
          }}
        />
      )}



      {showQrCode && <GenerateQrCode data={id} close={() => setShowQrCode(false)} />}
      <div className='align-items-center'>
        {(action.includes('view') && (
          <a
            // onClick={openEditModal}
            onClick={() => openEditModal(true)}
            className='btn btn-icon btn-bg-light btn-active-color-primary btn-sm me-1'
          >
            <KTIcon iconName='eye' className='fs-3' />
          </a>
        )) ||
          false}

        {/* {(action.includes('download') && (
          <>
            <a
              onClick={() => handleDownload()}
              className='btn btn-icon btn-bg-light btn-active-color-primary btn-sm me-1'
            >
              <KTIcon iconName='file-down' className='fs-3' />
            </a>
          </>
        )) ||
          false} */}

        {/* {((action.includes('edit') || action.includes('poIssued')) &&
          (test.length ? (
            'PO Issued'
          ) : (
            <a
              // onClick={openEditModal}
              onClick={() => openEditModal()}
              className='btn btn-icon btn-bg-light btn-active-color-primary btn-sm me-1'
            >
              <KTIcon iconName='pencil' className='fs-3' />
            </a>
          ))) ||
          false} */}

        {/* {((action.includes('edit') || action.includes('poIssued') || action.includes('InvoiceUploaded')) &&
          ((action.includes('poIssued') && test.length) ? (
            // 'PO Issued'
            <span style={{ color: '#50cd89', backgroundColor: '#e6ffe6', fontWeight: 'bold', padding: '2px 6px', borderRadius: '4px' }}>PO Issued</span>
          ) : (action.includes('InvoiceUploaded') && test2?.length) ? (
            'Invoice Uploaded'
          ) : (
            <a
              onClick={() => hasCompletedPayment ? null : openEditModal()}
              className={`btn btn-icon btn-bg-light ${hasCompletedPayment ? 'btn-disabled' : 'btn-active-color-primary'} btn-sm me-1`}
              style={{ cursor: hasCompletedPayment ? 'not-allowed' : 'pointer', opacity: hasCompletedPayment ? 0.6 : 1 }}
            >
              <KTIcon iconName='pencil' className='fs-3' />
            </a>
          ))) ||
          false} */}

        {/* {((action.includes('edit') || action.includes('poIssued') || action.includes('InvoiceUploaded')) &&
          ((action.includes('poIssued') && test.length) ? (
            // 'PO Issued'
            <span style={{ color: '#50cd89', backgroundColor: '#e6ffe6', fontWeight: 'bold', padding: '2px 6px', borderRadius: '4px' }}>PO Issued</span>
          ) : (action.includes('InvoiceUploaded') && test2?.length) ? (
            'Invoice Uploaded'
          ) : (
            <a
              onClick={() => hasCompletedPayment ? null : openEditModal()}
              className={`btn btn-icon btn-bg-light ${hasCompletedPayment ? 'btn-disabled' : 'btn-active-color-primary'} btn-sm me-1`}
              style={{ cursor: hasCompletedPayment ? 'not-allowed' : 'pointer', opacity: hasCompletedPayment ? 0.6 : 1 }}
            >
              <KTIcon iconName='pencil' className='fs-3' />
            </a>
          ))) ||
          false} */}

        {/* {(!shouldHideEdit() &&
          (action.includes('edit') ||
            action.includes('poIssued') ||
            action.includes('InvoiceUploaded')) &&
          (action.includes('poIssued') && test.length ? (
            // 'PO Issued'
            <span
              style={{
                color: '#50cd89',
                backgroundColor: '#e6ffe6',
                fontWeight: 'bold',
                padding: '2px 6px',
                borderRadius: '4px',
              }}
            >
              PO Issued
            </span>
          ) : action.includes('InvoiceUploaded') && test2?.length ? (
            'Invoice Uploaded'
          ) : (
            <a
              onClick={() => (hasCompletedPayment ? null : openEditModal())}
              className={`btn btn-icon btn-bg-light ${hasCompletedPayment ? 'btn-disabled' : 'btn-active-color-primary'
                } btn-sm me-1`}
              style={{
                cursor: hasCompletedPayment ? 'not-allowed' : 'pointer',
                opacity: hasCompletedPayment ? 0.6 : 1,
              }}
            >
              <KTIcon iconName='pencil' className='fs-3' />
            </a>
          ))) ||
          false} */}





        {showApprovalModal && (
          <ApprovalModal
            id={id}
            close={() => setShowApprovalModal(false)}
          />
        )}
        {showVerifyModal && (
          <VerifyModal
            id={id}
            close={() => setShowVerifyModal(false)}
          />
        )}
        {
          showSalesApprovalModal && (
            <SalesApprovalModal
              id={id}
              close={() => setShowSalesApprovalModal(false)}
            />
          )
        }

        {/* {action.includes('dropdown1') && pathname.startsWith('/apps/textile/textile-order-approval') && (
          <div style={{ position: 'relative', display: 'inline-block' }}>
            <button
              onClick={() => setShowDropdown(!showDropdown)}
              className='btn btn-sm btn-light-primary'
              style={{ minWidth: '100px' }}
            >
              Action
              <KTIcon iconName='down' className='fs-7 ms-2' />
            </button>

            {showDropdown && (
              <>
                <div
                  style={{
                    position: 'fixed',
                    top: 0,
                    left: 0,
                    right: 0,
                    bottom: 0,
                    zIndex: 999
                  }}
                  onClick={() => setShowDropdown(false)}
                />
                <div
                  style={{
                    position: 'absolute',
                    top: '100%',
                    right: 0,
                    marginTop: '4px',
                    backgroundColor: 'white',
                    border: '1px solid #e0e0e0',
                    borderRadius: '6px',
                    boxShadow: '0 2px 10px rgba(0,0,0,0.1)',
                    minWidth: '150px',
                    zIndex: 1000
                  }}
                >
                
                  <div
                    onClick={() => {
                      setShowApprovalModal(true)
                      setShowDropdown(false)
                    }}
                    style={{
                      fontWeight: 'bold',
                      padding: '12px 16px',
                      cursor: 'pointer',
                      borderBottom: '1px solid #f0f0f0',
                      color: '#50cd89'
                    }}
                    onMouseEnter={(e) => e.currentTarget.style.backgroundColor = '#f8f9fa'}
                    onMouseLeave={(e) => e.currentTarget.style.backgroundColor = 'white'}
                  >
                    Approve
                  </div>

            
                  <div
                    onClick={() => {
                      console.log('Order rejected:', id.id)
                      successToast('Order rejected')
                      setShowDropdown(false)
                     
                    }}
                    style={{
                      fontWeight: 'bold',
                      padding: '12px 16px',
                      cursor: 'pointer',
                      color: '#f8285a'
                    }}
                    onMouseEnter={(e) => e.currentTarget.style.backgroundColor = '#f8f9fa'}
                    onMouseLeave={(e) => e.currentTarget.style.backgroundColor = 'white'}
                  >
                    Reject
                  </div>
                </div>
              </>
            )}
          </div>
        )} */}


        {action.includes('dropdown1') && pathname.includes('/apps/textile/textile-order-approval') && (
          <>
            {/* {console.log('DEBUG - id:', id)}
            {console.log('DEBUG - financeApproval:', id?.financeApproval)}
            {console.log('DEBUG - approved:', id?.financeApproval?.approved)} */}

            {id?.financeApproval?.approved ? (
              // Show approved badge
              <span style={{
                color: '#50cd89',
                backgroundColor: '#e6ffe6',
                fontWeight: 'bold',
                padding: '8px 16px',
                borderRadius: '4px',
                display: 'inline-block',
                fontSize: '14px'
              }}>
                Approved
              </span>
            ) : (
              // Show dropdown
              <div style={{ position: 'relative', display: 'inline-block' }}>
                <button
                  onClick={() => setShowDropdown(!showDropdown)}
                  className='btn btn-sm btn-light-primary'
                  style={{ minWidth: '100px' }}
                >
                  Action
                  <KTIcon iconName='down' className='fs-7 ms-2' />
                </button>

                {showDropdown && (
                  <>
                    <div
                      style={{
                        position: 'fixed',
                        top: 0,
                        left: 0,
                        right: 0,
                        bottom: 0,
                        zIndex: 999
                      }}
                      onClick={() => setShowDropdown(false)}
                    />
                    <div
                      style={{
                        position: 'absolute',
                        top: '100%',
                        right: 0,
                        marginTop: '4px',
                        backgroundColor: 'white',
                        border: '1px solid #e0e0e0',
                        borderRadius: '6px',
                        boxShadow: '0 2px 10px rgba(0,0,0,0.1)',
                        minWidth: '150px',
                        zIndex: 1000
                      }}
                    >
                      {id?.status !== "VERIFIED" && (currentUser as any)?.role?.name === "PURCHASE_HEAD" &&
                        <div
                          onClick={() => {
                            setShowVerifyModal(true)
                            setShowDropdown(false)
                          }}
                          style={{
                            fontWeight: 'bold',
                            padding: '12px 16px',
                            cursor: 'pointer',
                            borderBottom: '1px solid #f0f0f0',
                            color: '#50cd89'
                          }}
                          onMouseEnter={(e) => e.currentTarget.style.backgroundColor = '#f8f9fa'}
                          onMouseLeave={(e) => e.currentTarget.style.backgroundColor = 'white'}
                        >
                          Verify
                        </div>
                      }
                      {id?.status !== "CREATED" && (currentUser as any)?.role?.name === "FINANCE_MANAGER" &&
                        <div
                          onClick={() => {
                            setShowApprovalModal(true)
                            setShowDropdown(false)
                          }}
                          style={{
                            fontWeight: 'bold',
                            padding: '12px 16px',
                            cursor: 'pointer',
                            borderBottom: '1px solid #f0f0f0',
                            color: '#50cd89'
                          }}
                          onMouseEnter={(e) => e.currentTarget.style.backgroundColor = '#f8f9fa'}
                          onMouseLeave={(e) => e.currentTarget.style.backgroundColor = 'white'}
                        >
                          Approve
                        </div>
                      }

                      <div
                        onClick={() => {
                          console.log('Order rejected:', id.id)
                          successToast('Order rejected')
                          setShowDropdown(false)
                        }}
                        style={{
                          fontWeight: 'bold',
                          padding: '12px 16px',
                          cursor: 'pointer',
                          color: '#f8285a'
                        }}
                        onMouseEnter={(e) => e.currentTarget.style.backgroundColor = '#f8f9fa'}
                        onMouseLeave={(e) => e.currentTarget.style.backgroundColor = 'white'}
                      >
                        Reject
                      </div>
                    </div>
                  </>
                )}
              </div>
            )}
          </>
        )}
        {action.includes('approveDropdown') && (
          <>
            {id?.status === "APPROVED" ? (
              // Show approved badge
              <span style={{
                // color: '#5054cdff',
                // backgroundColor: '#e6ebffff',
                backgroundColor: '#dfffea',
                color: '#1fc95f',
                fontWeight: 'bold',
                padding: '8px 16px',
                borderRadius: '4px',
                display: 'inline-block',
                fontSize: '14px'
              }}>
                Approved
              </span>
            ) : id?.status === "COMPLETED" ?
              (<span style={{
                backgroundColor: '#e9f3ff',
                color: '#1b84ff',
                fontWeight: 'bold',
                padding: '8px 16px',
                borderRadius: '4px',
                display: 'inline-block',
                fontSize: '14px'
              }}>
                Completed
              </span>)
              : (
                // Show dropdown
                <div style={{ position: 'relative', display: 'inline-block' }}>
                  <button
                    onClick={() => setShowDropdown(!showDropdown)}
                    className='btn btn-sm btn-light-primary'
                    style={{ minWidth: '100px' }}
                  >
                    Action
                    <KTIcon iconName='down' className='fs-7 ms-2' />
                  </button>

                  {showDropdown && (
                    <>
                      <div
                        style={{
                          position: 'fixed',
                          top: 0,
                          left: 0,
                          right: 0,
                          bottom: 0,
                          zIndex: 999
                        }}
                        onClick={() => setShowDropdown(false)}
                      />
                      <div
                        style={{
                          position: 'absolute',
                          top: '100%',
                          right: 0,
                          marginTop: '4px',
                          backgroundColor: 'white',
                          border: '1px solid #e0e0e0',
                          borderRadius: '6px',
                          boxShadow: '0 2px 10px rgba(0,0,0,0.1)',
                          minWidth: '150px',
                          zIndex: 1000
                        }}
                      >
                        {(currentUser as any)?.role?.name === "SALES_HEAD" && <div
                          onClick={() => {
                            setShowSalesApprovalModal(true)
                            setShowDropdown(false)
                          }}
                          style={{
                            fontWeight: 'bold',
                            padding: '12px 16px',
                            cursor: 'pointer',
                            borderBottom: '1px solid #f0f0f0',
                            color: '#50cd89'
                          }}
                          onMouseEnter={(e) => e.currentTarget.style.backgroundColor = '#f8f9fa'}
                          onMouseLeave={(e) => e.currentTarget.style.backgroundColor = 'white'}
                        >
                          Approve
                        </div>
                        }

                        {/* <div
                        onClick={() => {
                          console.log('Order rejected:', id.id)
                          successToast('Order rejected')
                          setShowDropdown(false)
                        }}
                        style={{
                          fontWeight: 'bold',
                          padding: '12px 16px',
                          cursor: 'pointer',
                          color: '#f8285a'
                        }}
                        onMouseEnter={(e) => e.currentTarget.style.backgroundColor = '#f8f9fa'}
                        onMouseLeave={(e) => e.currentTarget.style.backgroundColor = 'white'}
                      >
                        Reject
                      </div> */}
                      </div>
                    </>
                  )}
                </div>
              )}
          </>
        )}



        {action.includes('dropdown2') && pathname.includes('/apps/textile/textile-dispatch') && (
          <div style={{ position: 'relative', display: 'inline-block' }}>
            <button
              onClick={() => setShowDropdown(!showDropdown)}
              className='btn btn-sm btn-light-primary'
              style={{ minWidth: '100px' }}
            >
              Action
            </button>
            {showDropdown && (
              <>
                <div
                  style={{ position: 'fixed', top: 0, left: 0, right: 0, bottom: 0, zIndex: 999 }}
                  onClick={() => setShowDropdown(false)}
                />
                <div
                  style={{
                    position: 'absolute',
                    top: '100%',
                    right: 0,
                    backgroundColor: 'white',
                    borderRadius: '8px',
                    boxShadow: '0 4px 12px rgba(0,0,0,0.15)',
                    zIndex: 1000,
                    minWidth: '150px',
                    marginTop: '4px'
                  }}
                >
                  {(currentUser as any)?.role?.name === "PURCHASE_MANAGER" && <div
                    onClick={() => {
                      navigate(`/apps/textile/textile-dispatch/dispatch/${id.id}`, {
                        state: { transactionData: id }
                      })
                      setShowDropdown(false)
                    }}
                    style={{
                      fontWeight: 'bold',
                      padding: '12px 16px',
                      cursor: 'pointer',
                      borderBottom: '1px solid #f0f0f0',
                      color: '#50cd89'
                    }}
                    onMouseEnter={(e) => e.currentTarget.style.backgroundColor = '#f8f9fa'}
                    onMouseLeave={(e) => e.currentTarget.style.backgroundColor = 'white'}
                  >
                    Dispatch Now
                  </div>}
                  <div
                    onClick={() => {
                      // setShowHistoryModal(true)
                      navigate(`/apps/textile/textile-dispatch/history/${id.id}`, {
                        state: { transactionData: id }
                      })
                      setShowDropdown(false)
                    }}
                    style={{
                      fontWeight: 'bold',
                      padding: '12px 16px',
                      cursor: 'pointer'
                    }}
                    onMouseEnter={(e) => e.currentTarget.style.backgroundColor = '#f8f9fa'}
                    onMouseLeave={(e) => e.currentTarget.style.backgroundColor = 'white'}
                  >
                    View History
                  </div>
                </div>
              </>
            )}
          </div>
        )}
        {action.includes('dropdown2') && pathname.includes('/apps/textile/textile-logistics') && (
          <div style={{ position: 'relative', display: 'inline-block' }}>
            <button
              onClick={() => setShowDropdown(!showDropdown)}
              className='btn btn-sm btn-light-primary'
              style={{ minWidth: '100px' }}
            >
              Action
            </button>
            {showDropdown && (
              <>
                <div
                  style={{ position: 'fixed', top: 0, left: 0, right: 0, bottom: 0, zIndex: 999 }}
                  onClick={() => setShowDropdown(false)}
                />
                <div
                  style={{
                    position: 'absolute',
                    top: '100%',
                    right: 0,
                    backgroundColor: 'white',
                    borderRadius: '8px',
                    boxShadow: '0 4px 12px rgba(0,0,0,0.15)',
                    zIndex: 1000,
                    minWidth: '150px',
                    marginTop: '4px'
                  }}
                >
                  {id?.status === "FINANCE_APPROVED" && (currentUser as any)?.role?.name !== "FINANCE_MANAGER" && <div
                    onClick={() => {
                      navigate(`/apps/textile/textile-logistics/transport/${id.id}`, {
                        state: { transactionData: id }
                      })
                      setShowDropdown(false)
                    }}
                    style={{
                      fontWeight: 'bold',
                      padding: '12px 16px',
                      cursor: 'pointer',
                      borderBottom: '1px solid #f0f0f0',
                      color: '#50cd89'
                    }}
                    onMouseEnter={(e) => e.currentTarget.style.backgroundColor = '#f8f9fa'}
                    onMouseLeave={(e) => e.currentTarget.style.backgroundColor = 'white'}
                  >
                    Transport
                  </div>}

                  {((currentUser as any)?.role?.name === "PURCHASE_MANAGER" || (currentUser as any)?.role?.name === "PURCHASE_HEAD") && <div
                    onClick={() => {
                      setShowDropdown(false)
                      setShowApproveModal(true)
                    }}
                    style={{
                      fontWeight: 'bold',
                      padding: '12px 16px',
                      cursor: 'pointer',
                      borderBottom: '1px solid #f0f0f0',
                      color: '#50cd89'
                    }}
                    onMouseEnter={(e) => e.currentTarget.style.backgroundColor = '#f8f9fa'}
                    onMouseLeave={(e) => e.currentTarget.style.backgroundColor = 'white'}
                  >
                    Approve
                  </div>}
                </div>
              </>
            )}
          </div>
        )}






        {action.includes('dropdown2') && pathname.includes('/apps/textile/textile-history') && (
          <div style={{ position: 'relative', display: 'inline-block' }}>
            <button
              onClick={() => setShowDropdown(!showDropdown)}
              className='btn btn-sm btn-light-primary'
              style={{ minWidth: '100px' }}
            >
              Action
            </button>
            {showDropdown && (
              <>
                <div
                  style={{ position: 'fixed', top: 0, left: 0, right: 0, bottom: 0, zIndex: 999 }}
                  onClick={() => setShowDropdown(false)}
                />
                <div
                  style={{
                    position: 'absolute',
                    top: '100%',
                    right: 0,
                    backgroundColor: 'white',
                    borderRadius: '8px',
                    boxShadow: '0 4px 12px rgba(0,0,0,0.15)',
                    zIndex: 1000,
                    minWidth: '150px',
                    marginTop: '4px'
                  }}
                >
                  <div
                    onClick={() => {
                      console.log('id:', id)
                      console.log('id.id:', id.id)
                      console.log('navigating to:', `/apps/textile/textile-history/${id.id}`)
                      navigate(`/apps/textile/textile-history/${id.id}`)
                      setShowDropdown(false)
                    }}
                    style={{
                      fontWeight: 'bold',
                      padding: '12px 16px',
                      cursor: 'pointer'
                    }}
                    onMouseEnter={(e) => e.currentTarget.style.backgroundColor = '#f8f9fa'}
                    onMouseLeave={(e) => e.currentTarget.style.backgroundColor = 'white'}
                  >
                    View Shipment
                  </div>
                </div>
              </>
            )}
          </div>
        )}


        {action.includes('dropdown2') && pathname.includes('/apps/textile/coc-set-up') && (
          <div style={{ position: 'relative', display: 'inline-block' }}>
            <button
              onClick={() => setShowDropdown(!showDropdown)}
              className='btn btn-sm btn-light-primary'
              style={{ minWidth: '100px' }}
            >
              Action
            </button>
            {showDropdown && (
              <>
                <div
                  style={{ position: 'fixed', top: 0, left: 0, right: 0, bottom: 0, zIndex: 999 }}
                  onClick={() => setShowDropdown(false)}
                />
                <div
                  style={{
                    position: 'absolute',
                    top: '100%',
                    right: 0,
                    backgroundColor: 'white',
                    borderRadius: '8px',
                    boxShadow: '0 4px 12px rgba(0,0,0,0.15)',
                    zIndex: 1000,
                    minWidth: '150px',
                    marginTop: '4px'
                  }}
                >
                  <div
                    onClick={() => {
                      navigate(`/apps/textile/coc-set-up/${id.id}`, { state: { user: id } })
                      setShowDropdown(false)
                    }}
                    style={{
                      fontWeight: 'bold',
                      padding: '12px 16px',
                      cursor: 'pointer'
                    }}
                    onMouseEnter={(e) => e.currentTarget.style.backgroundColor = '#f8f9fa'}
                    onMouseLeave={(e) => e.currentTarget.style.backgroundColor = 'white'}
                  >
                    TCOC Report
                  </div>
                </div>
              </>
            )}
          </div>
        )}


        {action.includes('dropdown3') && pathname.includes('/apps/textile/textile-tracebility') && (
          <div style={{ position: 'relative', display: 'inline-block' }}>
            <button
              onClick={() => setShowDropdown(!showDropdown)}
              className='btn btn-sm btn-light-primary'
              style={{ minWidth: '100px' }}
            >
              Action
            </button>
            {showDropdown && (
              <>
                <div
                  style={{ position: 'fixed', top: 0, left: 0, right: 0, bottom: 0, zIndex: 999 }}
                  onClick={() => setShowDropdown(false)}
                />
                <div
                  style={{
                    position: 'absolute',
                    top: '100%',
                    right: 0,
                    backgroundColor: 'white',
                    borderRadius: '8px',
                    boxShadow: '0 4px 12px rgba(0,0,0,0.15)',
                    zIndex: 1000,
                    minWidth: '150px',
                    marginTop: '4px'
                  }}
                >
                  <div
                    onClick={() => {
                      setSelectedId(id?.id)
                      setShowDdpModal(true)
                      setShowDropdown(false)
                    }}
                    style={{
                      fontWeight: 'bold',
                      padding: '12px 16px',
                      cursor: 'pointer'
                    }}
                    onMouseEnter={(e) => e.currentTarget.style.backgroundColor = '#f8f9fa'}
                    onMouseLeave={(e) => e.currentTarget.style.backgroundColor = 'white'}
                  >
                    View DDP
                  </div>
                  <div
                    onClick={() => {
                      openEditModal()
                      setShowDropdown(false)
                    }}
                    style={{
                      fontWeight: 'bold',
                      padding: '8px 16px',
                      cursor: 'pointer'
                    }}
                    onMouseEnter={(e) => e.currentTarget.style.backgroundColor = '#f8f9fa'}
                    onMouseLeave={(e) => e.currentTarget.style.backgroundColor = 'white'}
                  >
                    Edit
                  </div>
                </div>
              </>
            )}
          </div>
        )}
        {/* {action.includes('dropdown') && (
          <div style={{ position: 'relative', display: 'inline-block' }}>
            <button
              onClick={() => setShowDropdown(!showDropdown)}
              className='btn btn-sm btn-light-primary'
              style={{ minWidth: '100px' }}
            >
              Action
              <KTIcon iconName='down' className='fs-7 ms-2' />
            </button>

            {showDropdown && (
              <>
                <div
                  style={{
                    position: 'fixed',
                    top: 0,
                    left: 0,
                    right: 0,
                    bottom: 0,
                    zIndex: 999
                  }}
                  onClick={() => setShowDropdown(false)}
                />
                <div
                  style={{
                    position: 'absolute',
                    top: '100%',
                    right: 0,
                    marginTop: '4px',
                    backgroundColor: 'white',
                    border: '1px solid #e0e0e0',
                    borderRadius: '6px',
                    boxShadow: '0 2px 10px rgba(0,0,0,0.1)',
                    minWidth: '120px',
                    zIndex: 1000
                  }}
                >
                  <div
                    onClick={() => {
                      openEditModal(true)
                      setShowDropdown(false)
                    }}
                    style={{
                      fontWeight: "bold",
                      padding: '8px 16px',
                      cursor: 'pointer',
                      borderBottom: showDeactivate ? '1px solid #f0f0f0' : 'none'
                    }}
                    onMouseEnter={(e) => e.currentTarget.style.backgroundColor = '#f8f9fa'}
                    onMouseLeave={(e) => e.currentTarget.style.backgroundColor = 'white'}
                  >
                    View
                  </div>
                  {showDeactivate && (
                    <div
                      onClick={() => {
                        setShowDeleteModal(true)
                        setShowDropdown(false)
                      }}
                      style={{
                        fontWeight: "bold",
                        padding: '8px 16px',
                        cursor: 'pointer',
                        color: id.status === 'INACTIVE' ? '#50cd89' : '#f8285a'
                      }}
                      onMouseEnter={(e) => e.currentTarget.style.backgroundColor = '#f8f9fa'}
                      onMouseLeave={(e) => e.currentTarget.style.backgroundColor = 'white'}
                    >
                      {id.status === 'INACTIVE' ? 'Activate' : 'Deactivate'}
                    </div>
                  )}
                </div>
              </>
            )}
          </div>
        )} */}


        {/* {action.includes('dropdown') && (
          <div style={{ position: 'relative', display: 'inline-block' }}>
            <button
              onClick={() => setShowDropdown(!showDropdown)}
              className='btn btn-sm btn-light-primary'
              style={{ minWidth: '100px' }}
            >
              Action
              <KTIcon iconName='down' className='fs-7 ms-2' />
            </button>

            {showDropdown && (
              <>
                  style={{
                    position: 'fixed',
                    top: 0,
                    left: 0,
                    right: 0,
                    bottom: 0,
                    zIndex: 999
                  }}
                  onClick={() => setShowDropdown(false)}
                />

               
                <div
                  style={{
                    position: 'absolute',
                    top: '100%',
                    right: 0,
                    marginTop: '4px',
                    backgroundColor: 'white',
                    border: '1px solid #e0e0e0',
                    borderRadius: '6px',
                    boxShadow: '0 2px 10px rgba(0,0,0,0.1)',
                    minWidth: '120px',
                    zIndex: 1000
                  }}
                >
                 
                  <div
                    onClick={() => {
                   
                    }}
                    style={{
                      fontWeight: 'bold',
                      padding: '8px 16px',
                      cursor: 'pointer',
                      borderBottom: '1px solid #f0f0f0'
                    }}
                    onMouseEnter={(e) => e.currentTarget.style.backgroundColor = '#f8f9fa'}
                    onMouseLeave={(e) => e.currentTarget.style.backgroundColor = 'white'}
                  >
                    View
                  </div>

                
                  {!(window.location.pathname === '/apps/finance/recycler' || window.location.pathname === '/apps/business/recycler') && (
                    <div
                      onClick={() => {
                        openEditModal(true)
                        setShowDropdown(false)
                      }}
                      style={{
                        fontWeight: 'bold',
                        padding: '8px 16px',
                        cursor: 'pointer',
                        borderBottom: showDeactivate ? '1px solid #f0f0f0' : 'none'
                      }}
                      onMouseEnter={(e) => e.currentTarget.style.backgroundColor = '#f8f9fa'}
                      onMouseLeave={(e) => e.currentTarget.style.backgroundColor = 'white'}
                    >
                      Approve
                    </div>
                  )}

                 
                  {showDeactivate && (
                    <div
                      onClick={() => {
                        setShowDeleteModal(true)
                        setShowDropdown(false)
                      }}
                      style={{
                        fontWeight: 'bold',
                        padding: '8px 16px',
                        cursor: 'pointer',
                        color: id.status === 'INACTIVE' ? '#50cd89' : '#f8285a'
                      }}
                      onMouseEnter={(e) => e.currentTarget.style.backgroundColor = '#f8f9fa'}
                      onMouseLeave={(e) => e.currentTarget.style.backgroundColor = 'white'}
                    >
                      {id.status === 'INACTIVE' ? 'Activate' : 'Deactivate'}
                    </div>
                  )}
                </div>
              </>
            )}
          </div>
        )} */}


        {/* {action.includes('dropdown') && (
          <div style={{ position: 'relative', display: 'inline-block' }}>
            <button
              onClick={() => setShowDropdown(!showDropdown)}
              className='btn btn-sm btn-light-primary'
              style={{ minWidth: '100px' }}
            >
              Action
              <KTIcon iconName='down' className='fs-7 ms-2' />
            </button>

            {showDropdown && (
              <>
                <div
                  style={{
                    position: 'fixed',
                    top: 0,
                    left: 0,
                    right: 0,
                    bottom: 0,
                    zIndex: 999
                  }}
                  onClick={() => setShowDropdown(false)}
                />
                <div
                  style={{
                    position: 'absolute',
                    top: '100%',
                    right: 0,
                    marginTop: '4px',
                    backgroundColor: 'white',
                    border: '1px solid #e0e0e0',
                    borderRadius: '6px',
                    boxShadow: '0 2px 10px rgba(0,0,0,0.1)',
                    minWidth: '120px',
                    zIndex: 1000
                  }}
                >
                  <div
                    onClick={() => {
                      navigate(`/apps/business/recycler/${id.id}`)
                      setShowDropdown(false)
                    }}
                    style={{
                      fontWeight: 'bold',
                      padding: '8px 16px',
                      cursor: 'pointer',
                      borderBottom: '1px solid #f0f0f0'
                    }}
                    onMouseEnter={(e) => e.currentTarget.style.backgroundColor = '#f8f9fa'}
                    onMouseLeave={(e) => e.currentTarget.style.backgroundColor = 'white'}
                  >
                    View
                  </div>
                  {!(
                    window.location.pathname === '/apps/finance/recycler' ||
                    window.location.pathname === '/apps/business/recycler'
                  ) && (
                      <div
                        onClick={() => {
                          openEditModal(true)
                          setShowDropdown(false)
                        }}
                        style={{
                          fontWeight: 'bold',
                          padding: '8px 16px',
                          cursor: 'pointer',
                          borderBottom: showDeactivate ? '1px solid #f0f0f0' : 'none'
                        }}
                        onMouseEnter={(e) => e.currentTarget.style.backgroundColor = '#f8f9fa'}
                        onMouseLeave={(e) => e.currentTarget.style.backgroundColor = 'white'}
                      >
                      Assign Field Executive
                      </div>
                    )}
                  {showDeactivate && (
                    <div
                      onClick={() => {
                        setShowDeleteModal(true)
                        setShowDropdown(false)
                      }}
                      style={{
                        fontWeight: 'bold',
                        padding: '8px 16px',
                        cursor: 'pointer',
                        color: id.status === 'INACTIVE' ? '#50cd89' : '#f8285a'
                      }}
                      onMouseEnter={(e) => e.currentTarget.style.backgroundColor = '#f8f9fa'}
                      onMouseLeave={(e) => e.currentTarget.style.backgroundColor = 'white'}
                    >
                      {id.status === 'INACTIVE' ? 'Activate' : 'Deactivate'}
                    </div>
                  )}
                </div>
              </>
            )}
          </div>
        )} */}


        {action.includes('dropdown') && (
          <div style={{ position: 'relative', display: 'inline-block' }}>
            <button
              onClick={() => setShowDropdown(!showDropdown)}
              className='btn btn-sm btn-light-primary'
              style={{ minWidth: '100px' }}
            >
              Action
              <KTIcon iconName='down' className='fs-7 ms-2' />
            </button>

            {showDropdown && (
              <>
                {/* Overlay to close dropdown */}
                <div
                  style={{
                    position: 'fixed',
                    top: 0,
                    left: 0,
                    right: 0,
                    bottom: 0,
                    zIndex: 999
                  }}
                  onClick={() => setShowDropdown(false)}
                />

                {/* Dropdown menu */}
                <div
                  style={{
                    position: 'absolute',
                    top: '100%',
                    right: 0,
                    marginTop: '4px',
                    backgroundColor: 'white',
                    border: '1px solid #e0e0e0',
                    borderRadius: '6px',
                    boxShadow: '0 2px 10px rgba(0,0,0,0.1)',
                    minWidth: '120px',
                    zIndex: 1000
                  }}
                >
                  {/* View */}
                  <div
                    onClick={() => {
                      // Determine the navigation path based on current location
                      const isRecycler = pathname.includes('/recycler');
                      const isFinance = pathname.includes('/finance');
                      const isBusiness = pathname.includes('/business');
                      const isSales = pathname.includes('/sales');
                      const isPurchase = pathname.includes('/purchase');

                      let targetPath = '';

                      if (isRecycler) {
                        // Navigate to recycler detail page
                        if (isFinance) {
                          targetPath = `/apps/finance/recycler/${id.id}`;
                        } else if (isBusiness) {
                          targetPath = `/apps/business/recycler/${id.id}`;
                        } else if (isSales) {
                          targetPath = `/apps/sales/recycler/${id.id}`;
                        }
                      } else {
                        // Navigate to collection-point detail page
                        if (isFinance) {
                          targetPath = `/apps/finance/collection-point/${id.id}`;
                        } else if (isBusiness) {
                          targetPath = `/apps/business/collection-point/${id.id}`;
                        } else if (isPurchase) {
                          targetPath = `/apps/purchase/collection-point/${id.id}`;
                        }
                      }

                      navigate(targetPath);
                      setShowDropdown(false);
                    }}
                    style={{
                      fontWeight: 'bold',
                      padding: '8px 16px',
                      cursor: 'pointer',
                      borderBottom: '1px solid #f0f0f0'
                    }}
                    onMouseEnter={(e) => e.currentTarget.style.backgroundColor = '#f8f9fa'}
                    onMouseLeave={(e) => e.currentTarget.style.backgroundColor = 'white'}
                  >
                    View
                  </div>

                  {/* Approve (hide on specific paths) */}
                  {!(
                    window.location.pathname === '/apps/finance/recycler' ||
                    window.location.pathname === '/apps/business/recycler' ||
                    window.location.pathname === '/apps/sales/recycler'
                  ) && (
                      <div
                        onClick={() => {
                          openEditModal(true)
                          setShowDropdown(false)
                        }}
                        style={{
                          fontWeight: 'bold',
                          padding: '8px 16px',
                          cursor: 'pointer',
                          borderBottom: showDeactivate ? '1px solid #f0f0f0' : 'none'
                        }}
                        onMouseEnter={(e) => e.currentTarget.style.backgroundColor = '#f8f9fa'}
                        onMouseLeave={(e) => e.currentTarget.style.backgroundColor = 'white'}
                      >
                        Assign Field Executive
                      </div>
                    )}

                  {/* Activate / Deactivate */}
                  {showDeactivate && (
                    id.status === 'IN_PROCESS' ?
                      (
                        <>
                          <div
                            onClick={() => {
                              setShowDeleteModal(true)
                              setActionType("ACTIVATE")
                              setShowDropdown(false)
                            }}
                            style={{
                              fontWeight: 'bold',
                              padding: '8px 16px',
                              cursor: 'pointer',
                              color: '#50cd89'
                            }}
                            onMouseEnter={(e) => e.currentTarget.style.backgroundColor = '#f8f9fa'}
                            onMouseLeave={(e) => e.currentTarget.style.backgroundColor = 'white'}
                          >
                            Activate
                          </div>
                          <div
                            onClick={() => {
                              setShowDeleteModal(true)
                              setActionType("DEACTIVATE")
                              setShowDropdown(false)
                            }}
                            style={{
                              fontWeight: 'bold',
                              padding: '8px 16px',
                              cursor: 'pointer',
                              color: '#f8285a'
                            }}
                            onMouseEnter={(e) => e.currentTarget.style.backgroundColor = '#f8f9fa'}
                            onMouseLeave={(e) => e.currentTarget.style.backgroundColor = 'white'}
                          >
                            Deactivate
                          </div>
                        </>
                      ) :
                      (<div
                        onClick={() => {
                          setShowDeleteModal(true)
                          setActionType(id.status === 'INACTIVE' ? 'ACTIVATE' : 'DEACTIVATE')
                          setShowDropdown(false)
                        }}
                        style={{
                          fontWeight: 'bold',
                          padding: '8px 16px',
                          cursor: 'pointer',
                          color: id.status === 'INACTIVE' ? '#50cd89' : '#f8285a'
                        }}
                        onMouseEnter={(e) => e.currentTarget.style.backgroundColor = '#f8f9fa'}
                        onMouseLeave={(e) => e.currentTarget.style.backgroundColor = 'white'}
                      >
                        {id.status === 'INACTIVE' ? 'Activate' : 'Deactivate'}
                      </div>)
                  )
                  }
                </div>
              </>
            )}
          </div>
        )}





















        {/* tring showing edit btn starts here */}
        {/* For Business Paths */}


        {(!shouldHideSettingsEdit() &&
          pathname.includes('/apps/settings') &&
          (action.includes('edit') ||
            action.includes('poIssued') ||
            action.includes('InvoiceUploaded')) &&
          (action.includes('poIssued') && test.length ? (
            <span
              style={{
                color: '#50cd89',
                backgroundColor: '#e6ffe6',
                fontWeight: 'bold',
                padding: '2px 6px',
                borderRadius: '4px',
              }}
            >
              PO Issued
            </span>
          ) : action.includes('InvoiceUploaded') && test2?.length ? (
            'Invoice Uploaded'
          ) : (
            <a
              onClick={() => (hasCompletedPayment ? null : openEditModal())}
              className={`btn btn-icon btn-bg-light ${hasCompletedPayment ? 'btn-disabled' : 'btn-active-color-primary'
                } btn-sm me-1`}
              style={{
                cursor: hasCompletedPayment ? 'not-allowed' : 'pointer',
                opacity: hasCompletedPayment ? 0.6 : 1,
              }}
            >
              <KTIcon iconName='pencil' className='fs-3' />
            </a>
          ))) ||
          false}



        {(!shouldHideEditBusiness() &&
          pathname.includes('/apps/business') &&
          (action.includes('edit') ||
            action.includes('poIssued') ||
            action.includes('InvoiceUploaded')) &&
          (action.includes('poIssued') && test.length ? (
            <span
              style={{
                color: '#50cd89',
                backgroundColor: '#e6ffe6',
                fontWeight: 'bold',
                padding: '2px 6px',
                borderRadius: '4px',
              }}
            >
              PO Issued
            </span>
          ) : action.includes('InvoiceUploaded') && test2?.length ? (
            'Invoice Uploaded'
          ) : (
            <a
              onClick={() => (hasCompletedPayment ? null : openEditModal())}
              className={`btn btn-icon btn-bg-light ${hasCompletedPayment ? 'btn-disabled' : 'btn-active-color-primary'
                } btn-sm me-1`}
              style={{
                cursor: hasCompletedPayment ? 'not-allowed' : 'pointer',
                opacity: hasCompletedPayment ? 0.6 : 1,
              }}
            >
              <KTIcon iconName='pencil' className='fs-3' />
            </a>
          ))) ||
          false}

        {/* For Finance Paths */}
        {(!shouldHideEditFinance() &&
          pathname.includes('/apps/finance') &&
          (action.includes('edit') ||
            action.includes('poIssued') ||
            action.includes('InvoiceUploaded')) &&
          (action.includes('poIssued') && test.length ? (
            <span
              style={{
                color: '#50cd89',
                backgroundColor: '#e6ffe6',
                fontWeight: 'bold',
                padding: '2px 6px',
                borderRadius: '4px',
              }}
            >
              PO Issued
            </span>
          ) : action.includes('InvoiceUploaded') && test2?.length ? (
            'Invoice Uploaded'
          ) : (
            <a
              onClick={() => (hasCompletedPayment ? null : openEditModal())}
              className={`btn btn-icon btn-bg-light ${hasCompletedPayment ? 'btn-disabled' : 'btn-active-color-primary'
                } btn-sm me-1`}
              style={{
                cursor: hasCompletedPayment ? 'not-allowed' : 'pointer',
                opacity: hasCompletedPayment ? 0.6 : 1,
              }}
            >
              <KTIcon iconName='pencil' className='fs-3' />
            </a>
          ))) ||
          false}

        {(!shouldHideEditLogistics() &&
          pathname.includes('/apps/logic') &&
          (action.includes('edit') ||
            action.includes('poIssued') ||
            action.includes('InvoiceUploaded')) &&
          (action.includes('poIssued') && test.length ? (
            <span
              style={{
                color: '#50cd89',
                backgroundColor: '#e6ffe6',
                fontWeight: 'bold',
                padding: '2px 6px',
                borderRadius: '4px',
              }}
            >
              PO Issued
            </span>
          ) : action.includes('InvoiceUploaded') && test2?.length ? (
            'Invoice Uploaded'
          ) : (
            <a
              onClick={() => (hasCompletedPayment ? null : openEditModal())}
              className={`btn btn-icon btn-bg-light ${hasCompletedPayment ? 'btn-disabled' : 'btn-active-color-primary'
                } btn-sm me-1`}
              style={{
                cursor: hasCompletedPayment ? 'not-allowed' : 'pointer',
                opacity: hasCompletedPayment ? 0.6 : 1,
              }}
            >
              <KTIcon iconName='pencil' className='fs-3' />
            </a>
          ))) ||
          false}




        {/* {(!shouldHideEditPurchase() &&
          pathname.includes('/apps/purchase') &&
          (action.includes('edit') ||
            action.includes('poIssued') ||
            action.includes('InvoiceUploaded')) &&
          (action.includes('poIssued') && test.length ? (
            <span
              style={{
                color: '#50cd89',
                backgroundColor: '#e6ffe6',
                fontWeight: 'bold',
                padding: '2px 6px',
                borderRadius: '4px',
              }}
            >
              PO Issued
            </span>
          ) : action.includes('InvoiceUploaded') && test2?.length ? (
            'Invoice Uploaded'
          ) : (
            <a
              onClick={() => (hasCompletedPayment ? null : openEditModal())}
              className={`btn btn-icon btn-bg-light ${hasCompletedPayment ? 'btn-disabled' : 'btn-active-color-primary'
                } btn-sm me-1`}
              style={{
                cursor: hasCompletedPayment ? 'not-allowed' : 'pointer',
                opacity: hasCompletedPayment ? 0.6 : 1,
              }}
            >
              <KTIcon iconName='pencil' className='fs-3' />
            </a>
          ))) ||
          false} */}



        {(!shouldHideEditPurchase() &&
          pathname.includes('/apps/purchase') &&
          (action.includes('edit') ||
            action.includes('poIssued') ||
            action.includes('InvoiceUploaded')) &&
          (action.includes('poIssued') && test.length ? (
            <span
              style={{
                color: '#50cd89',
                backgroundColor: '#e6ffe6',
                fontWeight: 'bold',
                padding: '2px 6px',
                borderRadius: '4px',
              }}
            >
              PO Issued
            </span>
          ) : action.includes('InvoiceUploaded') && test2?.length ? (
            'Invoice Uploaded'
          ) : pathname.includes('/apps/purchase/varified-listing') ? (
            // Show Approve button for varified-listing path
            <button
              onClick={() => (hasCompletedPayment ? null : openEditModal())}
              className={`btn btn-sm ${hasCompletedPayment ? 'btn-secondary' : 'btn-primary'}`}
              style={{
                cursor: hasCompletedPayment ? 'not-allowed' : 'pointer',
                opacity: hasCompletedPayment ? 0.6 : 1,
              }}
              disabled={hasCompletedPayment}
            >
              Action
            </button>
          ) : (
            // Show pencil icon for other purchase paths

            <a onClick={() => (hasCompletedPayment ? null : openEditModal())}
              className={`btn btn-icon btn-bg-light ${hasCompletedPayment ? 'btn-disabled' : 'btn-active-color-primary'
                } btn-sm me-1`}
              style={{
                cursor: hasCompletedPayment ? 'not-allowed' : 'pointer',
                opacity: hasCompletedPayment ? 0.6 : 1,
              }}
            >
              <KTIcon iconName='pencil' className='fs-3' />
            </a>
          ))) ||
          false}

        {(!shouldHideEditSales() &&
          pathname.includes('/apps/sales') &&
          (action.includes('edit') ||
            action.includes('poIssued') ||
            action.includes('InvoiceUploaded')) &&
          (action.includes('poIssued') && test.length ? (
            <span
              style={{
                color: '#50cd89',
                backgroundColor: '#e6ffe6',
                fontWeight: 'bold',
                padding: '2px 6px',
                borderRadius: '4px',
              }}
            >
              PO Issued
            </span>
          ) : action.includes('InvoiceUploaded') && test2?.length ? (
            'Invoice Uploaded'
          ) : pathname.includes('/apps/sales/order-management') && id?.remainingQuantity <= 0 ? <span
            style={{
              color: '#50cd89',
              backgroundColor: '#e6ffe6',
              fontWeight: 'bold',
              padding: '2px 6px',
              borderRadius: '4px',
            }}
          >
            Completed
          </span> : (
            <a
              onClick={() => (hasCompletedPayment ? null : openEditModal())}
              className={`btn btn-icon btn-bg-light ${hasCompletedPayment ? 'btn-disabled' : 'btn-active-color-primary'
                } btn-sm me-1`}
              style={{
                cursor: hasCompletedPayment ? 'not-allowed' : 'pointer',
                opacity: hasCompletedPayment ? 0.6 : 1,
              }}
            >
              <KTIcon iconName='pencil' className='fs-3' />
            </a>
          ))) ||
          false}






        {/* For Textile Paths */}
        {(!shouldHideEditTextile() &&
          pathname.includes('/apps/textile') &&
          action.includes('edit') && (

            <a onClick={() => openEditModal()}
              className='btn btn-icon btn-bg-light btn-active-color-primary btn-sm me-1'
            >
              <KTIcon iconName='pencil' className='fs-3' />
            </a>
          )) ||
          false}

        {/* For Transactions Paths */}
        {(!shouldHideEditTransactions() &&
          pathname.includes('/apps/transactions') &&
          (action.includes('edit') ||
            action.includes('poIssued') ||
            action.includes('InvoiceUploaded')) &&
          (action.includes('poIssued') && test.length ? (
            <span
              style={{
                color: '#50cd89',
                backgroundColor: '#e6ffe6',
                fontWeight: 'bold',
                padding: '2px 6px',
                borderRadius: '4px',
              }}
            >
              PO Issued
            </span>
          ) : action.includes('InvoiceUploaded') && test2?.length ? (
            'Invoice Uploaded'
          ) : (
            <a
              onClick={() => (hasCompletedPayment ? null : openEditModal())}
              className={`btn btn-icon btn-bg-light ${hasCompletedPayment ? 'btn-disabled' : 'btn-active-color-primary'
                } btn-sm me-1`}
              style={{
                cursor: hasCompletedPayment ? 'not-allowed' : 'pointer',
                opacity: hasCompletedPayment ? 0.6 : 1,
              }}
            >
              <KTIcon iconName='pencil' className='fs-3' />
            </a>
          ))) ||
          false}
        {/* tring showing edit btn ends here */}












        {/* For Textile Paths - Dropdown with Edit and View */}
        {pathname.includes('/apps/textile/textile-user-managment') && action.includes('userEdit') && (
          <div style={{ position: 'relative', display: 'inline-block' }}>
            <button
              onClick={() => setShowDropdown(!showDropdown)}
              className='btn btn-sm btn-light-primary'
              style={{ minWidth: '100px' }}
            >
              Action
              <KTIcon iconName='down' className='fs-7 ms-2' />
            </button>

            {showDropdown && (
              <>
                <div
                  style={{
                    position: 'fixed',
                    top: 0,
                    left: 0,
                    right: 0,
                    bottom: 0,
                    zIndex: 999
                  }}
                  onClick={() => setShowDropdown(false)}
                />
                <div
                  style={{
                    position: 'absolute',
                    top: '100%',
                    right: 0,
                    marginTop: '4px',
                    backgroundColor: 'white',
                    border: '1px solid #e0e0e0',
                    borderRadius: '6px',
                    boxShadow: '0 2px 10px rgba(0,0,0,0.1)',
                    minWidth: '120px',
                    zIndex: 1000
                  }}
                >
                  {/* View */}
                  <div
                    onClick={() => {
                      navigate(`/apps/textile/textile-user-managment/${id.id}`)
                      setShowDropdown(false)
                    }}
                    style={{
                      fontWeight: 'bold',
                      padding: '8px 16px',
                      cursor: 'pointer',
                      borderBottom: '1px solid #f0f0f0'
                    }}
                    onMouseEnter={(e) => e.currentTarget.style.backgroundColor = '#f8f9fa'}
                    onMouseLeave={(e) => e.currentTarget.style.backgroundColor = 'white'}
                  >
                    View
                  </div>

                  {/* Edit */}
                  <div
                    onClick={() => {
                      openEditModal()
                      setShowDropdown(false)
                    }}
                    style={{
                      fontWeight: 'bold',
                      padding: '8px 16px',
                      cursor: 'pointer'
                    }}
                    onMouseEnter={(e) => e.currentTarget.style.backgroundColor = '#f8f9fa'}
                    onMouseLeave={(e) => e.currentTarget.style.backgroundColor = 'white'}
                  >
                    Edit
                  </div>
                </div>
              </>
            )}
          </div>
        )}
























        {/* {( !shouldHideEdit()) && (action.includes('edit') || action.includes('poIssued') || action.includes('InvoiceUploaded')) &&
          ((action.includes('poIssued') && test.length) ? (
            <span style={{ color: '#50cd89', backgroundColor: '#e6ffe6', fontWeight: 'bold', padding: '2px 6px', borderRadius: '4px' }}>PO Issued</span>
          ) : (action.includes('InvoiceUploaded') && test2?.length) ? (
            'Invoice Uploaded'
          ) : (
            <a
              onClick={() => hasCompletedPayment ? null : openEditModal()}
              className={`btn btn-icon btn-bg-light ${hasCompletedPayment ? 'btn-disabled' : 'btn-active-color-primary'} btn-sm me-1`}
              style={{ cursor: hasCompletedPayment ? 'not-allowed' : 'pointer', opacity: hasCompletedPayment ? 0.6 : 1 }}
            >
              <KTIcon iconName='pencil' className='fs-3' />
            </a>
          ))} */}

        {/* {(action.includes('edit') && !shouldHideEdit() && (
          (action.includes('poIssued') && test.length) ||
          (action.includes('InvoiceUploaded') && test2.length)
        )) && (
            <div
              style={{
                color: '#50cd89',
                backgroundColor: '#e6ffe6',
                fontWeight: 'bold',
                padding: '2px 6px',
                borderRadius: '4px'
              }}
              onClick={() => hasCompletedPayment ? null : openEditModal()}
              className={`btn btn-icon btn-bg-light ${hasCompletedPayment ? 'btn-disabled' : 'btn-active-color-primary'} btn-sm me-1`}
            >
              <span style={{ marginRight: '4px' }}>
                {action.includes('poIssued') ? 'PO Issued' : 'Invoice Uploaded'}
              </span>
              <span
                style={{
                  cursor: hasCompletedPayment ? 'not-allowed' : 'pointer',
                  opacity: hasCompletedPayment ? 0.6 : 1
                }}
              >
                <KTIcon
                  iconName='pencil'
                  className='fs-3'
                />
              </span>
            </div>
          )} */}

        {action.includes('assign') && (
          <>
            {id.status && id.status === 'Pickup Assigned' ? (
              '-----'
            ) : (
              <a
                onClick={async () =>
                  allData.status &&
                    ['completed', 'pickup completed'].includes(allData.status.toLowerCase())
                    ? ''
                    : showAssignHubModal()
                }
                style={{
                  cursor:
                    allData.status &&
                    ['completed', 'pickup completed'].includes(allData.status.toLowerCase()) &&
                    'not-allowed',
                }}
              >
                Assign Rider
              </a>
            )}
          </>
        )}



        {/* {action.includes('delete') && action.includes('edit') && (
          <a
            onClick={async () => await deleteItem.mutateAsync()}
            className='btn btn-icon btn-bg-light btn-active-color-primary btn-sm'
          >
            <KTIcon iconName='trash' className='fs-3' />
          </a>
        )} */}






        {(action.includes('delete') && action.includes('edit') || action.includes('delete')) && (
          <a
            // onClick={async () => await deleteItem.mutateAsync()}
            onClick={() => setShowDeleteModal(!showDeleteModal)}
            className='btn btn-icon btn-bg-light btn-active-color-primary btn-sm'
          >
            <KTIcon iconName='trash'
              // className='fs-3'
              // className={`fs-3 ${pathname.includes('/apps/business/recycler') ||
              //   pathname.includes('/apps/finance/recycler') ||
              //   pathname.includes('/apps/sales/recycler')
              //   ? 'text-danger'
              //   : ''
              //   }`}
              className='fs-3 text-danger'
            />
          </a>
        )}








        {(action.includes('toggle') && (
          <div className='btn btn-icon btn-active-color-secondary'>
            <div className='form-switch'>
              <input
                className='form-check-input'
                type='checkbox'
                id='allowmarketing'
                defaultChecked={id.status === 'ACTIVE' ? true : false}
                onChange={async () => {
                  await toggleStatus.mutateAsync()
                }}
              />
            </div>
          </div>
        )) ||
          false}
        {(action.includes('qr') &&
          (id.status === 'Accepted' ||
            pathname.includes('collect-orders') ||
            pathname.includes('collection-point')) && (
            <a
              onClick={() => setShowQrCode(true)}
              className='btn btn-icon btn-bg-light btn-active-color-primary btn-sm me-1'
            >
              <KTIcon iconName='code' className='fs-3' />
            </a>
          )) ||
          false}
      </div>
      {/* <div
        className='menu menu-sub menu-sub-dropdown menu-column menu-rounded menu-gray-600 menu-state-bg-light-primary fw-bold fs-7 w-125px py-4'
        data-kt-menu='true'
      >
        <div className='menu-item px-3'>
          <a className='menu-link px-3' onClick={openEditModal}>
            Edit
          </a>
        </div>

        <div className='menu-item px-3'>
          <a
            className='menu-link px-3'
            data-kt-users-table-filter='delete_row'
            onClick={async () => await deleteItem.mutateAsync()}
          >
            Delete
          </a>
        </div>
      </div> */}

      {showDdpModal && (
        <>
          <div
            style={{
              position: 'fixed',
              top: 0,
              left: 0,
              right: 0,
              bottom: 0,
              backgroundColor: 'rgba(0,0,0,0.5)',
              zIndex: 1050
            }}
            onClick={() => setShowDdpModal(false)}
          />
          <div
            style={{
              position: 'fixed',
              top: '50%',
              left: '50%',
              transform: 'translate(-50%, -50%)',
              backgroundColor: 'white',
              borderRadius: '12px',
              zIndex: 1051,
              width: '90vw',
              maxWidth: '600px',
              maxHeight: '90vh',
              overflow: 'auto'
            }}
          >
            <button
              onClick={() => setShowDdpModal(false)}
              style={{
                position: 'absolute',
                top: '10px',
                right: '10px',
                background: 'none',
                border: 'none',
                fontSize: '24px',
                cursor: 'pointer',
                zIndex: 10
              }}
            >
              &times;
            </button>
            <DdpModal user={id} />
          </div>
        </>
      )}

      {showApproveModal && (
        <ViewApproveModal id={id} close={() => setShowApproveModal(false)} />
      )}

      {showHistoryModal && (
        <>
          <div
            style={{
              position: 'fixed',
              top: 0,
              left: 0,
              right: 0,
              bottom: 0,
              backgroundColor: 'rgba(0,0,0,0.5)',
              zIndex: 1050
            }}
            onClick={() => setShowHistoryModal(false)}
          />
          <div
            style={{
              position: 'fixed',
              top: '50%',
              left: '50%',
              transform: 'translate(-50%, -50%)',
              backgroundColor: 'white',
              borderRadius: '12px',
              zIndex: 1051,
              width: '90vw',
              maxWidth: '800px',
              maxHeight: '80vh',
              overflow: 'auto',
              padding: '20px'
            }}
          >
            <div className='d-flex justify-content-between align-items-center mb-5'>
              <h3 className='fw-bold m-0'>Dispatch History</h3>
              <button
                onClick={() => setShowHistoryModal(false)}
                style={{
                  background: 'none',
                  border: 'none',
                  fontSize: '24px',
                  cursor: 'pointer'
                }}
              >
                &times;
              </button>
            </div>
            <DispatchHistory />
          </div>
        </>
      )}
    </>
  )
}

export { UserActionsCell }
